import { AbsoluteCenter, Box, Spinner, Text, VStack } from '@chakra-ui/react';

function OverlaySpinnerWrapper({ children, show, isFixed, borderRadius, message }) {
  return (
    <Box position={isFixed ? undefined : 'relative'}>
      {children}
      {show && (
        <Box
          position={isFixed ? 'fixed' : 'absolute'}
          top={0}
          left={0}
          right={0}
          bottom={0}
          bg="white"
          opacity={0.7}
          zIndex={9999}
          borderRadius={borderRadius}
        >
          <AbsoluteCenter>
            <VStack spacing={3}>
              <Spinner />
              {message && (
                <Text fontSize="sm" color="gray.600">
                  {message}
                </Text>
              )}
            </VStack>
          </AbsoluteCenter>
        </Box>
      )}
    </Box>
  );
}

export default OverlaySpinnerWrapper;
